import Vue from 'vue'
import router from './router'
import store from './store'
import Router from './component/Router.vue'
import { closeSpashscreen } from '../util'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import messageService from 'vue-update-message'

import './_asset/scss/app.scss'
import 'swiper/dist/css/swiper.css'

Vue.use(VueAwesomeSwiper)

// Message
const ConfigMsg = {
  position: 'fixed',
  width: '20vw',
  placement: 'bottom',
  successText: '#0B3B24',
  successBackground: '#CEF6CE',
  successBorder: '#0B3B24',
  errorText: '#B40404',
  errorBackground: '#F6CED8',
  errorBorder: '#B40404'
}
Vue.use(messageService, ConfigMsg)

export const render = (user, business) => {
  new Vue({
    router,
    store,
    render: h => h(Router),
    beforeCreate () {
      if (user.role !== 'producer') user.profile = business.profile
      this.$store.commit('user', user)
      this.$store.commit('business', business)
      // Redirect for the correct profile
      if (this.$route.name === 'main') {
        if (user.role === 'producer') this.$router.push('/bordero') // Producer
        else if (business.profile.indexOf('admin') > -1) this.$router.push('/dashboard')
        else if (business.profile.indexOf('register') > -1) this.$router.push('/event')
        else if (business.profile.indexOf('ticket') > -1 || business.profile.indexOf('sellOnlyReserved') > -1) this.$router.push('/ticket')
        else if (business.profile.indexOf('validator') > -1) this.$router.push('/validator')
      }
    },
    mounted () {
      closeSpashscreen(this)
    }
  }).$mount('#app')
}
